export default __webpack_public_path__ + "static/media/sports.b0934ed0.svg";